import React from 'react';
import { FcRating } from 'react-icons/fc';
import styled from 'styled-components';
import { DarkThemeColor } from '../../utils';
import Card from './Card';

function RatingCard(props) {
    const RankColor = {
        color: props.rankColor ? props.rankColor : '#00ff00'
    };
    return (
        <Card clickCardHandler={props.clickCardHandler} icon={FcRating}>
            <Rate>
                <div style={RankColor}>
                    <label>رتبه: </label>{props.customerRate}
                </div>
                <div>
                    <label>گروه: </label>{props.customerGroup}
                </div>
            </Rate>
        </Card>
    );
}
const Rate = styled.span`
    color: ${DarkThemeColor};
    width: 100%;
    margin: 12px 20px;
    display: inline-block;
    font-size: x-large;
    label{
        font-weight: bold;
    }
`;
export default RatingCard;